import type { LogoStylesLegacy } from '../schemas';

/**
 * CSS custom properties for the logo widget — the TS twin of `logo.base.less`
 * next to it, shared by the editor (websites) and the published renderer
 * (websites-builder).
 *
 * Only one value is dynamic: the box's width cap, which the control seeds from
 * the picked file's natural width. Everything else the old sheet emitted was
 * static — including the empty-state branch, which is a class rather than a
 * variable (see {@link logoImageCssClass}).
 */

/** Width cap for the logo box, in px. `null` removes the property. */
export function logoMaxWidthCss(maxWidth: LogoStylesLegacy['maxWidth'] | null | undefined): string | null {
    return maxWidth != null ? `${maxWidth}px` : null;
}

/**
 * Image class for the published renderer, which swaps rules entirely when no file
 * is picked (the blank placeholder is centred absolutely instead of laid out in
 * flow). The two are mutually exclusive, mirroring the old JSS's two branches.
 *
 * **The editor does not use this.** Its own stylesheet always applied the
 * has-a-file rules — it never consumed the JSS sheet at all — so its template
 * binds `logo-image` unconditionally, and the empty-state rule lives only in the
 * builder's `.less`. Preserving that split is deliberate, not an oversight.
 */
export function logoImageCssClass(hasImage: boolean): string {
    return hasImage ? 'logo-image' : 'logo-image-empty';
}
